import store from '@/store';
import requestAPI from '../requestBeApi';

const contractsService = {
  async getPersonalizedContract(self: Record<string, any>): Promise<void> {
    store.commit('contracts/setFetchingContract', true);

    let url = `/api/v1/assessment-requests/${self.projectId}/contract`;
    store.state.userRole === 'client' ? (url += `?assessor_id=${self.assessorId}`) : url;

    const response = await requestAPI({ url, method: 'GET' });

    if (response.ok) {
      const hasContract = response.status !== 204;
      if (hasContract) {
        const data = await response.json();
        store.commit('contracts/setShortContract', data.html);
      } else {
        store.commit('contracts/setShortContract', '');
      }
    } else if (response.status !== 401) {
      self.$message.error(self.$t('someErrorOccurred'));
    }

    store.commit('contracts/setFetchingContract', false);
  },
};

export default contractsService;
